export default __webpack_public_path__ + "static/media/smile-white.4378728a.svg";